import { compact, uniq } from 'lodash';

import { LineModel } from '@/lib/models/lines/types';

/**
 * Extracts Service Lines names from Line,
 * if carrierIds are provided, only their ids will be returned
 */
export const getServiceLineNames = (line: LineModel, carrierIds?: string[]) => {
  const services = line.sharedCarriers.map((service) => service);
  const filteredServices = carrierIds?.length ? services.filter((s) => carrierIds.includes(s.carrierId)) : services;

  return uniq(compact(filteredServices.map((service) => service.serviceName))).join(' / ');
};
